<template>
  <div class="single-column-content pa-5 ma-3">
    <page-title title="Set account manager password"></page-title>
    <h1 class="title mb-5">Set account manager password</h1>
    <form
      v-if="!hideForm"
      action="/set-password"
      @submit.prevent="submit"
      class="login-form"
    >
      <v-layout column>
        <v-flex class="text-input-container">
          <label> New password</label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.password"
            solo
            type="password"
            name="password"
            autocomplete="current-password"
            v-validate="'required|min:8'"
            :error-messages="errors.collect('password')"
            data-vv-name="password"
            ref="password"
          ></v-text-field>
        </v-flex>
        <v-flex class="text-input-container">
          <label> Confirm password </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.confirmPassword"
            solo
            type="password"
            name="Confirm Password"
            ref="confirmPassword"
            v-validate="'required|min:8|confirmed:password'"
            data-vv-as="password"
            :error-messages="errors.collect('Confirm Password')"
            data-vv-name="Confirm Password"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row justify-center class="mb-3">
        <v-btn
          color="primary"
          type="submit"
          depressed
          round
          large
          :loading="submitLoading"
          >{{ $t('submit') }}</v-btn
        >
      </v-layout>
    </form>
    <h3 class="ma-3 text-md-center" v-if="hideForm" v-html="msg">
      
    </h3>
    
  </div>
</template>

<script>
import formMixins from '@/mixins/forms'
import userApi from '@/api/user'
export default {
  name: 'Login',
  mixins: [formMixins],
  created: function() {},
  data: function() {
    return {
      formData: {
        password: '',
        confirmPassword: '',
        token: this.$router.currentRoute.query.token
      },
      hideForm: !this.$router.currentRoute.query.token,
      msg: 'Expired link.'
    }
  },
  computed: {},
  methods: {
    submit: function() {
      const vm = this
      if (!this.isFormValid) return
      userApi.setPassword(vm.formData).then(function(res) {
        if (res.data.errors.length === 0) {
          vm.msg =
            'You have successfully set your password. Please <a class="link" href="/login"> login </a> to continue.'
          vm.hideForm = true
        } else {
          vm.hideForm = false
          vm.addFormError(
            'password',
            'Reset failed. This may be due to an expired token.'
          )
        }
      })
    }
  }
}
</script>

<style lang="stylus">
@require "common.styl"
    .single-column-content {
        width 500px
    }
</style>
